import 'responsive-tabs';
import { initEmblaCarousels } from './embla-slider';

(function ($) {
    $(function () {
      const $tabs = $(".js-responsive-tabs");

      let collapseOnMobile,
        isMobile = false;
      if ($tabs.length) {
        isMobile = window.innerWidth <= $tabs.data("mob-breakpoint");
        collapseOnMobile =
          $tabs.data("collapse-mobile") === true ||
          $tabs.data("collapse-mobile") === "true";
      }

      var $responsiveTabs = $(
        ".site-homepage__book-feeds, .js-responsive-tabs"
      );
      //homepage
      $responsiveTabs.responsiveTabs({
        setHash: false,
        scrollToAccordion: true,
        scrollToAccordionOnLoad: false,
        accordionTabElement: "<h2></h2>",
        duration: 300,
        collapsible: true,
        startCollapsed: isMobile && collapseOnMobile,
        active: 0,
        activate: function (event, tab) {
          const $tabPanel = $(tab.selector);

          if ($tabPanel.find(".carousel-wrapper").length) {
            const $slider = $tabPanel.find(".carousel-wrapper");
            const $sliderContainer = $tabPanel.find(".isbn-carousel");

            window.requestAnimationFrame(() => {
              $slider.removeClass("is-ready");
              if ($sliderContainer[0]) {
                initEmblaCarousels($sliderContainer[0]);
              }
            });
            $(window).trigger("resize");
            setTimeout(() => {
              $slider.addClass("is-ready");
            }, 400);
          }
        },
      });
    });
})(jQuery);
